import React, { useState } from 'react';
import { Header } from './Header';
import { Statistics } from './Statistics';
import { RoomOverview } from './RoomOverview';
import { RoomStatus } from './RoomStatus';
import { OccupancyChart } from './OccupancyChart';
import { FeedbackSection } from './FeedbackSection';
import styles from './Dashboard.module.css';
import AvailModel from '../FrontComponent/AvailModel';
import { RoomOccupancyStatus } from './RoomOccupancyStatus';

export const MainContent = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const hotelId = localStorage.getItem('hotel');

  return (
    <main className={styles.mainContent}>
      <Header showCreateBookingBtn={false} />
      <Statistics hotelId={hotelId} />
      <RoomOverview hotelId={hotelId} />
      <div className={styles.gridContainer}>
        <div className={styles.statusSection}>
          <RoomStatus hotelId={hotelId} />
          <RoomOccupancyStatus hotelId={hotelId} />
        </div>
        <div className={styles.feedSection}>
          <OccupancyChart hotelId={hotelId} />
          <FeedbackSection hotelId={hotelId} />
        </div>
      </div>
      {/* <AvailModel
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        hotelId={hotelId}
      /> */}
    </main>
  );
};
